module.exports = __webpack_public_path__ + "static/media/logo.aeda1b43.svg";